module.exports = __webpack_public_path__ + "static/media/avatar.cb979a51.png";